/**
 * @class LocalizationForm
 */
if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (!this.form) return;

      this.onChange = this.onChange.bind(this);
      this.form.addEventListener('change', this.onChange);
    }
    onChange() {
      if (!this.form) return;

      // Standard Shopify behavior: submit localization form on change.
      if (typeof this.form.requestSubmit === 'function') {
        this.form.requestSubmit();
      } else {
        this.form.submit();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);
}